
import type { RouteObject } from 'react-router-dom';
import Layout from '../components/customer/Layout';
import ScrollToTop from '../components/ScrollToTop';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import NewsRouteHandler from '../pages/news-detail/NewsRouteHandler';
import ContactPage from '../pages/contact/page';
import AcademyPage from '../pages/academy/page';
import AdminPage from '../pages/admin/page';
import LoginPage from '../pages/login/page';
import UnauthorizedPage from '../pages/unauthorized/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import SolutionsPage from '../pages/solutions/page';
import StackwayCRMPage from '../pages/stackway-crm/page';
import AIAutomationServicePage from '../pages/ai-automation-service/page';
import SecurityAssessmentServicePage from '../pages/security-assessment-code-review/page';
import ServiceImplementDevsecopsPage from '../pages/service-implement-devsecops/page';
import CustomSoftwareDevelopmentPage from '../pages/custom-software-development/page';
import StackWaySkillHubPage from '../pages/stackway-skill-hub/page';
import DigitalTransformationConsultingPage from '../pages/digital-transformation-consulting/page';
const routes: RouteObject[] = [
  // Trang có Layout chung
  {
    path: "/",
    element: (
      <Layout>
        <ScrollToTop />
        <HomePage />
      </Layout>
    ),
  },
  {
    path: "/ve-chung-toi",
    element: (
      <Layout>
        <ScrollToTop />
        <AboutPage />
      </Layout>
    ),
  },
  {
    path: "/giai-phap-va-dich-vu",
    element: (
      <Layout>
        <ScrollToTop />
        <SolutionsPage />
      </Layout>
    ),
  },
  {
    path: "/tin-tuc",
    element: (
      <Layout>
        <ScrollToTop />
        <NewsRouteHandler />
      </Layout>
    ),
  },
  {
    path: "/tin-tuc/*",
    element: (
      <Layout>
        <ScrollToTop />
        <NewsRouteHandler />
      </Layout>
    ),
  },
  {
    path: "/lien-he",
    element: (
      <Layout>
        <ScrollToTop />
        <ContactPage />
      </Layout>
    ),
  },
  {
    path: "/academy/stackway-academy",
    element: (
      <Layout>
        <ScrollToTop />
        <AcademyPage />
      </Layout>
    ),
  },
  // Trang không có Layout (admin, login, unauthorized)
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/unauthorized",
    element: <UnauthorizedPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/chinh-sach-bao-mat",
    element: (
      <Layout>
        <ScrollToTop />
        <PrivacyPolicyPage />
      </Layout>
    ),
  },
  // Các route cụ thể phải đặt TRƯỚC route động để React Router match đúng
  {
    path: "/giai-phap/stackway-crm",
    element: (
      <Layout>
        <ScrollToTop />
        <StackwayCRMPage />
      </Layout>
    ),
  },
  {
    path: "/giai-phap/stackskill-nen-tang-danh-gia-phat-trien-ky-nang",
    element: (
      <Layout>
        <ScrollToTop />
        <StackWaySkillHubPage />
      </Layout>
    ),
  },
  // Route động phải đặt SAU các route cụ thể
  {
    path: "/giai-phap/:slug",
    element: (
      <Layout>
        <ScrollToTop />
        <SolutionsPage />
      </Layout>
    ),
  },
  {
    path: "/dich-vu/tich-hop-ai-tu-dong-hoa-doanh-nghiep",
    element: (
      <Layout>
        <ScrollToTop />
        <AIAutomationServicePage />
      </Layout>
    ),
  },
  {
    path: "/dich-vu/security-assessment-code-review",
    element: (
      <Layout>
        <ScrollToTop />
        <SecurityAssessmentServicePage />
      </Layout>
    ),
  },
  {
    path: "/dich-vu/trien-khai-devsecops-cho-doanh-nghiep",
    element: (
      <Layout>
        <ScrollToTop />
        <ServiceImplementDevsecopsPage />
      </Layout>
    ),
  },
  {
    path: "/dich-vu/phat-trien-phan-mem-theo-yeu-cau",
    element: (
      <Layout>
        <ScrollToTop />
        <CustomSoftwareDevelopmentPage />
      </Layout>
    ),
  },
  {
    path: "/dich-vu/tu-van-chuyen-doi-so",
    element: (
      <Layout>
        <ScrollToTop />
        <DigitalTransformationConsultingPage />
      </Layout>
    ),
  },
  {
    path: "*",
    element: (
      <Layout>
        <ScrollToTop />
        <NewsRouteHandler />
      </Layout>
    ),
  },
];

export default routes;
